import { jsx as s } from "react/jsx-runtime";
import { c as a } from "./clsx-OuTLNxxd.js";
import { i as l } from "./index-DNCSvd9d.js";
const p = ({ color: t, size: o, opacity: e = 1, className: r }) => {
  const i = a(l({ color: t, size: o }), r);
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12.78 9.58",
      width: "12.78",
      height: "9.58",
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: { "--opacity": e },
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M10.538 0L12.1748 1.67813L4.18828 9.47297L0 5.47359L1.61906 3.77859L4.17047 6.21516L10.538 0Z"
        }
      )
    }
  );
};
export {
  p as C
};
